import { useTranslation } from 'react-i18next';
import { Rechtshinweis } from '../../entities';
import { RechtshinweiseCell } from '../Cells/RechtshinweiseCell';
import { RechtshinweiseRow } from './RechtshinweiseRow';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@e2n/ui';

export function RechtshinweiseTooltip({
  rechtshinweise,
}: {
  rechtshinweise: {
    rechtshinweise: Rechtshinweis[];
  };
}) {
  const { t } = useTranslation();
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger
          className={`${
            rechtshinweise.rechtshinweise ? 'cursor-auto' : 'cursor-pointer'
          }`}>
          <div className="flex">
            <RechtshinweiseCell
              rechtshinweise={rechtshinweise.rechtshinweise}
            />
          </div>
        </TooltipTrigger>
        {rechtshinweise.rechtshinweise.length > 0 && (
          <TooltipContent
            side="bottom"
            className="border border-neutrals-300 bg-white text-sm w-[400px] p-0">
            <div className="font-bold uppercase tracking-widespace-y-2 px-3 pt-2 text-neutrals-700">
              {rechtshinweise.rechtshinweise.length > 1
                ? t('domain.arbeitszeiten.uebersicht.tooltips.rechtshinweise')
                : t('domain.arbeitszeiten.uebersicht.tooltips.rechtshinweis')}
            </div>
            {!rechtshinweise ? (
              <div>Error</div>
            ) : (
              rechtshinweise.rechtshinweise.map((rechtshinweis, id) => (
                <RechtshinweiseRow key={id} rechtshinweise={[rechtshinweis]} />
              ))
            )}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
